import { getRoot } from "mobx-state-tree";
import { toJS } from "mobx";

export const integrationsStoreViews = self => ({
  get token() {
    return getRoot(self).authStore.token;
  },
  get merchantId() {
    return getRoot(self).authStore.managingStore?.id; // Added optional chaining for safety
  }
});
